import productComments from "../components/productComments";
export default function getComments(productCommentsContainer) {
    fetch("https://jsonplaceholder.typicode.com/comments")
        .then(function (response) {
        if (response.ok) {
            return response.json();
        }
        else {
            throw Error("Error de conexión con el servidor.");
        }
    })
        .then(function (data) {
        var dataReduced = data.slice(0, 10);
        dataReduced.forEach(function (comment) {
            productCommentsContainer.innerHTML += productComments(comment);
        });
    })
        .catch(function (err) {
        productCommentsContainer.innerHTML += "\n        <div class=\"product-details-comments-item\">\n            <h3>" + err + "</h3>\n        </div>\n        ";
    });
}
